if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[data-add-to-cart]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        const urlParams = new URLSearchParams(window.location.search);

        // Verificar se o parâmetro 'variant' está presente
        if (!urlParams.has('variant')) {
          // Se o parâmetro não estiver presente, desativar o botão
          this.toggleSubmitButton(true, 'SELECIONE O TAMANHO');
        } else {
          const selectedVariant = document.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
          const parsedSelectedVariant = JSON.parse(selectedVariant);
          // Se o parâmetro estiver presente, habilitar o botão
          if (parsedSelectedVariant.available) {
            this.toggleSubmitButton(false, 'ADICIONAR AO CARRINHO');
          } else {
            this.toggleSubmitButton(true, 'ESGOTADO');
          }
        }
      }

      onSubmitHandler = async (evt) => {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        try {
          // Primeira requisição: adicionando produto principal
          const response = await fetch(`${routes.cart_add_url}`, config).then((res) => res.json());

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }

          const yampiButton = false;

          // Renderizar o carrinho com o produto principal adicionado
          await this.cart.renderContents(response, false);

          const giftElement = document.querySelector('[data-gift]');
          if (giftElement) {
            const minimumValue = parseFloat(giftElement.getAttribute('data-value'));
            const giftVariantId = giftElement.getAttribute('data-gift');

            if (isNaN(minimumValue) || !giftVariantId) {
              console.error('Valores inválidos para mínimo ou variante do brinde.');
              return; // Retorna sem tentar adicionar o brinde se os dados forem inválidos
            }
          } else {
            console.log('Elemento [data-gift] não encontrado. Ignorando verificação de brinde.');
            return; // Retorna sem tentar adicionar o brinde se o elemento não existir
          }

          if (isNaN(minimumValue) || !giftVariantId) {
            console.error('Valores inválidos para mínimo ou variante do brinde.');
            return; // Retorna sem tentar adicionar o brinde se os dados forem inválidos
          }

          // Fetch do carrinho para verificar o total
          const cartData = await fetch(`${routes.cart_url}.json`).then((res) => res.json());

          // Corrigindo a comparação: Garantir que o cartTotal seja comparado corretamente com o valor mínimo
          const cartTotal = parseFloat(
            cartData.items.reduce((acc, item) => acc + (item.price * item.quantity) / 100, 0)
          ); // Supondo que o preço esteja em centavos

          // Verificar se o brinde já está no carrinho
          const isGiftInCart = cartData.items.some((item) => item.variant_id === parseInt(giftVariantId));

          // Verificar se o valor total do carrinho atinge o valor mínimo para adicionar o brinde
          if (cartTotal < minimumValue) {
            console.log(`O valor mínimo (${minimumValue}) não foi atingido. Total do carrinho: ${cartTotal}`);
            return; // Retorna sem tentar adicionar o brinde
          }

          // Se o valor mínimo for atingido e o brinde não estiver no carrinho, adicionar o brinde
          if (!isGiftInCart) {
            const giftConfig = { ...config };
            const giftFormData = new FormData();
            giftFormData.append('id', giftVariantId);
            giftFormData.append('quantity', 1);

            // Adicionando os parâmetros solicitados para o brinde
            if (this.cart) {
              giftFormData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              giftFormData.append('sections_url', window.location.pathname);
            }

            giftFormData.append('form_type', 'product');
            giftFormData.append('utf8', '✓');
            giftConfig.body = giftFormData;

            // Adiciona o brinde
            const giftResponse = await fetch(`${routes.cart_add_url}`, giftConfig).then((res) => res.json());

            if (!giftResponse.status) {
              // Atualiza o carrinho com o brinde
              await this.cart.renderContents(giftResponse, false);
            }
          } else {
            console.log('O brinde já está no carrinho.');
          }
        } catch (error) {
          console.error(error);
        } finally {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        }
      };

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
